/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable operator-linebreak */
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

interface NavMenuProps {
  active: boolean;
}

interface NavTextLinkProps {
  expanded: number;
}

export const NavMenu = styled.nav<NavMenuProps>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  width: 80px;
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  padding-left: 30px;
  background-color: #111;
  transition: 0.5s;
  overflow-x: hidden;
  padding-top: 30px;
  white-space: nowrap;
  :hover {
    width: 275px;
  }
`;

export const NavMenuItems = styled.ul`
  width: 100%;
  padding-left: 0;
  display: flex;
  flex-direction: column;
`;

export const NavText = styled.li`
  display: flex;
  height: 45px;
  &:hover {
    cursor: pointer;
  }
`;

export const LogoContainer = styled.div`
  height: 35px;
  width: max-content;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
`;

export const LogoImg = styled.img`
  width: auto;
  height: 25px;
  margin-right: 16px;
`;

export const Icon = styled.img`
  & * {
    fill: red;
  }
`;

export const NavTextLink = styled(NavLink)<NavTextLinkProps>`
  text-decoration: none;
  color: #f5f5f5;
  font-size: 16px;
  height: 100%;
  display: flex;
  align-items: center;
  border-radius: 4px;
  ${({ expanded }) =>
    expanded &&
    `
    width: 200px;
  `}
  &.active {
    color: #2dcafc;
  }
  &.active svg {
    fill: ${() => '#2DCAFC'};
  }
  &:hover svg {
    fill: ${() => '#2DCAFC'};
  }
`;

export const NavTextWithoutLink = styled.a<NavTextLinkProps>`
  text-decoration: none;
  color: #f5f5f5;
  font-size: 16px;
  height: 100%;
  display: flex;
  align-items: center;
  border-radius: 4px;
  ${({ expanded }) =>
    expanded &&
    `
    width: 200px;
  `}

  &.active {
    color: #2dcafc;
  }
  &.active svg {
    fill: ${() => '#2DCAFC'};
  }
  &:hover svg {
    fill: ${() => '#2DCAFC'};
  }
`;

export const NavTextTitle = styled.span`
  margin-left: 30px;
`;

interface IMainContainer {
  backgroundColor: string;
}

export const MainContainer = styled.div<IMainContainer>`
  padding: 30px;
  min-height: 100vh;
  background-color: ${props => props.backgroundColor};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  margin-left: 80px;
`;

export const NotificationWrapper = styled.div<NavTextLinkProps>`
  display: flex;
  align-items: center;
  color: #fff;
  height: 60px;
  ${({ expanded }) =>
    expanded &&
    `
    width: 200px;
  `}
  &.active {
    color: #2dcafc;
  }
  &:hover {
    color: #2dcafc;
    cursor: pointer;
  }
  &.active svg {
    fill: ${() => '#2DCAFC'};
  }
  &:hover svg {
    fill: ${() => '#2DCAFC'};
  }
`;
